import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import {
    FormGroup,
    Label,

} from 'reactstrap';

 // app config
 import AppConfig from 'Constants/AppConfig';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    sendStudentAgreement,
    acceptStudentAgreement
} from 'Actions';

function TabContainer({ children }) {
    return (
       <Typography component="div" style={{ padding: 8 * 3 }}>
          {children}
       </Typography>
    );
 }


class ViewAgreement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cstid:this.props.data.cstid,
            vfm:this.props.data.vfm,
            activeIndex:0,
            loader:false,

        };
    }

    sendAgreement(id) {
        this.setState({loader:true });
        this.props.sendStudentAgreement(id).then((data) => {   
            this.setState({loader:false });
            
        });
    }

    acceptAgreement(id) {
        this.setState({loader:true });
        this.props.acceptStudentAgreement(id).then((data) => {   
            this.setState({loader:false });            
        });
    }

    handleChangeIndex(index) {
        this.setState({ activeIndex: index });
    }
  
    handleChange(event, value) {
        this.setState({ activeIndex: value });
    }

    render() {

        const { particularagreementdetails, agreementprograminclusion, loading} = this.props; 
        
        const styles = {
            buttonProgress: {
                color: "green",
                position: 'absolute',
                top: '50%',
                left: '10%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
            },
        };
        return (
            <>
                <div className="row">
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>                        
                            <RctCollapsibleCard
                                heading={
                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                        <span>Agreement Details</span>
                                        <button type="button" className="mr-10 mb-10 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                    </div>
                                }
                            >
                             <div className="row">
                                <div className="col-sm-12 col-lg-6">
                                    <span>Student Name : <strong>{particularagreementdetails[0].studentname}</strong></span>
                                </div>
                                <div className="col-sm-12 col-lg-6">
                                    <span>Agreement Start Date : <strong>{particularagreementdetails[0].stdate}</strong></span>
                                </div>
                                <div className="col-sm-12 col-lg-6">
                                    <span>Academic Year : <strong>{particularagreementdetails[0].finacial}</strong></span>
                                </div> 
                                <div className="col-sm-12 col-lg-6">
                                    <span> Agreement End Date : <strong>{particularagreementdetails[0].eddate}</strong></span>
                                </div>                               
                                <div className="col-sm-12 col-lg-6">
                                    <span> Agreement Type : <strong>{particularagreementdetails[0].type}</strong></span>
                                </div>                                
                                <div className="col-sm-12 col-lg-6">
                                    <span> Agreement Execution Date :  <strong>{particularagreementdetails[0].exdate}</strong></span>
                                </div>
                             </div>   
                            </RctCollapsibleCard>                        
                    </div>
                    <div className="col-sm-12 col-lg-12">                        
                            <RctCollapsibleCard>
                              <div className="row">
                                <div className="col-sm-12 col-lg-6">
                                    {(particularagreementdetails[0].ctsa_acceptedBy==0 && this.state.vfm==1) ? 
                                       <div className="ddd"> 
                                        <div className="form-group" style={styles.wrapper}>
                                            <button className="mr-10 mb-10 btn btn-outline-success ml-auto" onClick={() => this.sendAgreement(particularagreementdetails[0].ctsaID)}>Send Agreement</button> 
                                            {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}    
                                        </div>
                                        </div>:""
                                    }

                                    {particularagreementdetails[0].ctsa_acceptedBy==0&&this.state.vfm==2 ? 
                                       <div className="ddd">
                                         <div className="form-group" style={styles.wrapper}>
                                            <button className="mr-10 mb-10 btn btn-outline-success ml-auto" onClick={() => this.acceptAgreement(particularagreementdetails[0].ctsaID)}>Accept</button> 
                                            {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}    
                                        </div>
                                        </div>:""
                                    }
                                </div>
                                <div className="col-sm-12 col-lg-6 text-right">
                                Note: Please read the Agreement, the Program Details and Code of Conduct documents before accepting.
                                </div>                                
                              </div>
                              <div className="col-sm-12 col-lg-12">
                                {particularagreementdetails[0].ctsa_programfilename!="" ?
                                    <Tabs
                                        value={this.state.activeIndex}
                                        onChange={(e, value) => this.handleChange(e, value)}
                                        textColor="primary"
                                        indicatorColor="primary"
                                        centered
                                    >
                                        <Tab label="Agreement" />
                                        <Tab label="Program Details" />
                                        <Tab label="Code of Conduct" />
                                        <Tab label="Program Inclusion" />
                                    </Tabs>
                                :""    
                                }
                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.activeIndex}
                                        onChangeIndex={(index) => this.handleChangeIndex(index)}>
                                        {particularagreementdetails[0].ctsa_acceptedBy==0 ?
                                            <TabContainer>
                                                <iframe src={AppConfig.apiurl+'/ctadminagreement?id='+particularagreementdetails[0].ctsaID} width="100%" height={800}  ></iframe>
                                            </TabContainer>
                                        :
                                            <TabContainer>
                                                <iframe src={AppConfig.apiurl+'/theme/img/agreement/'+particularagreementdetails[0].ctsa_filename} width="100%" height={800}  ></iframe>
                                            </TabContainer>
                                        }
                                        <TabContainer>
                                            <iframe src={AppConfig.apiurl+'/theme/img/agreement/'+particularagreementdetails[0].ctsa_programfilename} width="100%" height={800}  ></iframe>
                                        </TabContainer>
                                        <TabContainer>
                                        <iframe src={AppConfig.apiurl+'/theme/img/agreement/codeofconduct.pdf'} width="100%" height={800}  ></iframe>
                                        </TabContainer>
                                        <TabContainer>
                                        <div className="col-sm-12 col-lg-5" style={{margin:"0 auto"}}>  
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead style={{ backgroundColor: "transparent" }}>
                                                    <tr>
                                                        <th scope="col">SNO.</th>
                                                        <th scope="col">Name</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {agreementprograminclusion.map((p, index) => (
                                                        <tr key={p.csdID}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{p.name}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>   
                                        </div> 
                                        </TabContainer>
                                    </SwipeableViews>
                              </div>
                            </RctCollapsibleCard>                        
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = ({ contractstudent }) => {
    const { particularagreementdetails, agreementprograminclusion, loading } = contractstudent;
    return { particularagreementdetails, agreementprograminclusion, loading };

}

export default connect(mapStateToProps, {
    sendStudentAgreement,
    acceptStudentAgreement
})(ViewAgreement);